import { history, RootState } from 'store/store';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AuthCheckResponse } from '../domain/interfaces/auth-sign-in-response';
import { AuthRequestAuthCodePayload } from '../domain/interfaces/auth-request-auth-code-payload';
import { AuthRestorePayload } from '../domain/interfaces/auth-restore-payload';
import { AuthSignInPayload } from '../domain/interfaces/auth-sign-in-payload';
import { AuthSignUpPayload } from '../domain/interfaces/auth-sign-up-payload';
import { AuthSignUpResponse } from '../domain/interfaces/auth-sign-up-response';
import { Pages } from 'modules/navigation/domain/enums/pages';
import authService from '../domain/servcies/auth-service';

const PREFIX = 'auth';

const wait = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(() => resolve('ok'), ms);
  });

export const authRestore = createAsyncThunk<void, AuthRestorePayload>(`${PREFIX}/authRestore`, async () => {
  await wait(3000);
});

export const authSignIn = createAsyncThunk<void, AuthSignInPayload, { state: RootState }>(
  `${PREFIX}/authSignIn`,
  async (payload, { dispatch }) => {
    await authService.signIn(payload);
    dispatch(authCheck(payload.to));
    // const response = await authService.signIn(payload);
    // history.push(Pages.INDEX);
  },
);

export const authRequestAuthCode = createAsyncThunk<void, AuthRequestAuthCodePayload>(
  `${PREFIX}/authRequestAuthCode`,
  async (payload) => {
    await authService.requestAuthCode(payload);
  },
);

export const authSignOut = createAction(`${PREFIX}/authSignOut`, () => {
  authService.signOut();

  history.push(Pages.SIGN_IN);

  return {
    payload: null,
  };
});

export const authSignUp = createAsyncThunk<AuthSignUpResponse, AuthSignUpPayload>(`${PREFIX}/authSignUp`, async (payload) => {
  return authService.signUp(payload);
});

export const authCheck = createAsyncThunk<AuthCheckResponse | null, string | undefined, { state: RootState }>(
  `${PREFIX}/authCheck`,
  async (continueFrom) => {
    let result = null;

    try {
      result = await authService.check();
    } catch (err) {
      console.error('error', err);
    }

    if (!result) {
      history.push(Pages.SIGN_IN, { to: continueFrom });
    } else if (result.user) {
      history.push(continueFrom || Pages.INDEX);
    }

    return result;
  },
);

export const clearActiveTournamentId = createAction(`${PREFIX}/clearActiveTournamentId`);

export const switchUserTournament = createAction(`${PREFIX}/switchTournament`, (id: number) => {
  history.push(Pages.INDEX);

  return {
    payload: id,
  };
});
